<template>
  <div>
    <div class="container">
      <div class="hero-text">
        <h2>{{ filteredItem.name }}</h2>
        <p>{{ filteredItem.text }}</p>
      </div>
    </div>
    <div class="portfolio center">
      <ul :class="{ grid: filteredItem.link === 'who-stole-me' }">
        <li v-for="item in orderedMedia" :key="item.id" :class="item.type === 'video' ? 'iframe' : ''">
          <!-- Video -->
          <Iframe v-if="item.type === 'video'" :src="item.src" frameborder="0" allowfullscreen
            class="portfolio-video"></iframe>

          <!-- Image -->
          <div v-else-if="item.type === 'image'">
            <img :src="item.src" class="portfolio-image" />
            <p class="portfolio-text-block">{{ item.text }}</p>
          </div>
        </li>

        <!-- Always place iframe at the bottom -->
        <li v-if="iframeItem" class="iframe">
          <Iframe :src="iframeItem.src" />
        </li>
      </ul>

    </div>
  </div>
</template>

<script>
import content from "../../public/content.json";
import Iframe from "./Iframe";

export default {
  name: "PortfolioItem",
  components: {
    Iframe,
  },
  data() {
    return {
      content,
    };
  },
  computed: {
    filteredItem() {
      return this.content?.portfolio.find((x) => x.link === this.$route.params.id);
    },
    orderedMedia() {
      if (!this.filteredItem) return [];

      return this.filteredItem.media.map((item, index) => {
        if (item.img) {
          return { type: "image", src: item.img, text: item.imagetext || "", id: index };
        } else if (item.video) {
          return { type: "video", src: item.video, id: index };
        }
        return null;
      }).filter(Boolean); // Remove any null values
    },
    iframeItem() {
      return this.filteredItem?.iframe ? { type: "iframe", src: this.filteredItem.iframe } : null;
    }
  },

};
</script>

<style lang="scss" scoped>
$mobile: "screen and (max-width: 500px)";

.container {
  padding-top: 0;
}

.grid {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: var(--spacing-small);

  @media #{$mobile} {
    grid-gap: 0;
  }

  .portfolio-image {
    margin-bottom: 0;
  }
}

.portfolio-image {
  display: block;
  width: 100%;
  margin-bottom: var(--spacing-large);
}

.portfolio-text-block {
  margin: 0 auto;
  margin-bottom: var(--spacing-large);
}

.iframe {
  overflow: hidden;
  padding-top: 56.25%;
  position: relative;
  margin-bottom: var(--spacing-large);
}
.portfolio.center {
    max-width: 85vw;
    width: 85vw;
    margin: 0 auto;
}
</style>
